import { domains } from 'config/env'
import { buildClient } from './secondStepApi.shared'

export function makeClient(baseApiAddress) {
  return buildClient({ baseApiAddress })
}

const baseApiAddress = `${domains.SECONDSTEP_API}/`
const api = makeClient(baseApiAddress)

export default api
